import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Camera, Loader2, Paperclip, SendHorizontal } from "lucide-react";
import { CameraSheet } from "./CameraSheet";

const IMAGES = "image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif";

export const Composer = ({ onSend, onFile, onTyping, placeholder = "Mensagem", tel = false, busy = false, uploading = false, camera = false }) => {
  const [value, setValue] = useState("");
  const fileRef = useRef(null);
  const camRef = useRef(null);
  const [camOpen, setCamOpen] = useState(false);
  const pick = (e) => { const f = e.target.files?.[0]; if (f && onFile) onFile(f); e.target.value = ""; };

  const submit = (e) => {
    e.preventDefault();
    const t = value.trim();
    if (!t || busy) return;
    onSend(t);
    setValue("");
  };

  return (
    <motion.form onSubmit={submit} className="lz-composer" data-testid="chat-composer"
      initial={{ y: "100%" }} animate={{ y: 0 }} transition={{ type: "spring", stiffness: 300, damping: 30 }}>
      <div className="lz-field">
        <button type="button" data-testid="composer-attach" className="lz-clip" aria-label="Anexar arquivo"
          disabled={!onFile || uploading} onClick={() => fileRef.current?.click()}>
          {uploading ? <Loader2 size={19} className="animate-spin" /> : <Paperclip size={19} />}
        </button>
        <input ref={fileRef} type="file" hidden data-testid="composer-file-input" accept={IMAGES} onChange={pick} />
        <input data-testid="composer-input" className="lz-input" value={value} placeholder={placeholder}
          type={tel ? "tel" : "text"} inputMode={tel ? "tel" : "text"} autoComplete={tel ? "tel" : "off"}
          enterKeyHint="send" maxLength={tel ? 20 : 2000}
          onChange={(e) => { setValue(e.target.value); onTyping?.(); }} />
        {camera && (
          <>
            <button type="button" data-testid="composer-camera" className="lz-clip lz-cam" aria-label="Tirar foto"
              disabled={!onFile || uploading} onClick={() => setCamOpen(true)}>
              <Camera size={20} />
            </button>
            <input ref={camRef} type="file" hidden data-testid="composer-camera-input" accept="image/*" capture="environment" onChange={pick} />
            <CameraSheet open={camOpen} onClose={() => setCamOpen(false)} onCapture={(f) => onFile?.(f)} onFallback={() => camRef.current?.click()} />
          </>
        )}
      </div>
      <motion.button type="submit" data-testid="composer-send" className="lz-send" aria-label="Enviar"
        disabled={busy || !value.trim()} whileTap={{ scale: 0.9 }}>
        <SendHorizontal size={20} />
      </motion.button>
    </motion.form>
  );
};
